import React from 'react';

// Components
import AddARegistryLink from '../../components/AddARegistryLink';
import BuildZolaRegistryCTA from '../../components/BuildZolaRegistryCTA';
import SeeSamplePageLink from '../../components/SeeSamplePageLink';

// Styles
import styles from './RegistryOnboardControl.module.less';

const RegistryOnboardControl = ({ variant = false }) => {
  return (
    <div className={`container-fluid ${styles.container}`}>
      <div className={styles.ctaContainer}>
        <h1>Start Your Zola Registry</h1>
        <h4>
          We have one store with all the gifts couples want, smart time-saving tools, and one-on-one
          support you won’t find anywhere else.
        </h4>
        <SeeSamplePageLink />
        <BuildZolaRegistryCTA
          ctaText={variant ? 'Get Started With a Fun Quiz' : 'Build Your Zola Registry'}
          hasExternalRegistry={false}
          className={styles.btnSpacing}
        />
        <section className="add-another-registry">
          <p className="add-another-registry__info">
            <b>Have a registry at another store?</b> Link to it on this page.
          </p>
          <AddARegistryLink className="add-another-registry__btn" />
        </section>
      </div>
      <div className={styles.imgContainer} />
    </div>
  );
};

export default RegistryOnboardControl;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/RegistryOnboardControl/RegistryOnboardControl.jsx